import { render, staticRenderFns } from "./ActionsVenta.vue?vue&type=template&id=b661a0a6"
import script from "./ActionsVenta.vue?vue&type=script&lang=js"
export * from "./ActionsVenta.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports